import { action } from '@play-co/replicant';
import createActions from 'src/replicant/config/actions/createActions';

export const championsLeagueActions = createActions({
  /**
   * Mark champions league arena as seen.
   */
  setChampionsLeagueTutorialSeen: action((state, _, api) => {
    if (!state.championsLeague) {
      state.championsLeague = {};
    }
    state.championsLeague.tutorialSeenAt = api.date.now();
  }),
});
